export default (...args) => {
  try {
    if (window && window.analytics && window.analytics.track) {
      window.analytics.track(...args);
    }
  } catch (e) {
    if (window && window.newrelic && window.newrelic.noticeError) {
      const err = new Error('Could not log err to Segment');
      window.newrelic.noticeError(err, {
        e,
        args,
      });
    }
  }
};
